export default __webpack_public_path__ + "static/mobile-screen-4da7f4259fef5cb15e080d8fb42cfc1b.png";